<template>
  <div style="width: 100%">
    <v-card>
      <v-card-title
        >Event Admin<v-icon right
          >mdi-phone-rotate-landscape</v-icon
        ></v-card-title
      >
      <div v-if="!loggedIn">
        <NeedLogin></NeedLogin>
      </div>
      <div v-else>
        <SelectHappForAdmin
          @happ_changed="happSelected"
          v-if="showHappList"
        ></SelectHappForAdmin>

        <v-container fluid>
          <v-row class="mb-8">
            <v-col cols="2">
              <v-btn
                v-if="!showHappList"
                @click="showHappList = !showHappList"
                small
                rounded
                color="primary"
                >Show Events</v-btn
              >
            </v-col>
            <v-col
              ><v-chip small
                >Selected event: {{ this.happname }}
              </v-chip></v-col
            >
          </v-row>
          <!-- <p>{{ radio || "null" }}</p> -->
          <v-row>
            <v-col cols="2">
              <v-radio-group
                v-model="radio"
                @change="radiochanged"
                dense
                v-if="happIsSelected"
              >
                <v-radio
                  label="SMS"
                  value="Sms"
                  off-icon="mdi-cellphone-message"
                  :disabled="!IsHappAdmin"
                ></v-radio>
                <v-radio
                  label="Event Roles"
                  value="happAdmins"
                  off-icon="mdi-account-edit-outline"
                  :disabled="!IsHappAdmin"
                ></v-radio>
                <v-radio
                  label="Edit"
                  value="Edit"
                  off-icon="mdi-square-edit-outline"
                  :disabled="!IsHappAdmin"
                ></v-radio>
                <v-radio
                  label="Create"
                  value="Create"
                  off-icon="mdi-plus-circle-outline"
                ></v-radio>
                <v-radio
                  label="Delete"
                  value="Delete"
                  off-icon="mdi-trash-can-outline"
                  :disabled="!IsHappAdmin"
                ></v-radio>
                <v-radio
                  label="Transfer pilots to box"
                  value="Transfer pilots to box"
                  off-icon="mdi-database-arrow-right-outline"
                  :disabled="!IsBoxAdmin"
                  v-if="IsHappAdmin"
                ></v-radio>
              </v-radio-group>
            </v-col>
            <v-col>
              <div v-if="radionumber == 1">
                {{ radio }} - Not implemented yet
              </div>
              <div v-if="radionumber == 2">
                {{ radio }} - Not implemented yet
                <!-- <happRoles v-bind="posthapp"></happRoles> -->
              </div>
              <div v-if="radionumber == 3">
                {{ radio }} - Not implemented yet
              </div>
              <div v-if="radionumber == 4">
                <CreateHapp v-bind="postregidac"></CreateHapp>
              </div>
              <div v-if="radionumber == 5">
                <Deletehapp v-bind="posthapp"></Deletehapp>
                <!-- {{ radio }} - Not implemented yet -->
              </div>
              <div v-if="radionumber == 6">
                <TransferPilotsFromHappToBox
                  v-bind="posthapp"
                ></TransferPilotsFromHappToBox>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-row align="center" justify="center">
        <v-chip class="white--text" color="green" depressed v-if="IsHappAdmin">
          Event Admin
        </v-chip>
        <v-chip class="white--text" color="green" depressed v-if="IsBoxAdmin">
          Box Admin
        </v-chip>
      </v-row>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import SelectHappForAdmin from "@/components/happ/SelectHappForAdmin.vue";
import NeedLogin from "@/components/Admin/NeedLogin.vue";
import CreateHapp from "@/components/Admin/CreateHapp.vue";
// import happRoles from "@/components/Admin/happRoles.vue";
// import Createhapp from "@/components/Admin/Createhapp.vue";
import Deletehapp from "@/components/Admin/DeleteHapp.vue";
import axios from "axios";
import TransferPilotsFromHappToBox from "@/components/Admin/TransferPilotsFromHappToBox.vue";

export default {
  name: "Lsb",
  data() {
    return {
      startInput: 0,
      cookieToken: Number,
      cookieRegId: Number,
      regId: Number,
      ac: String,
      happ: [],
      happname: String,
      happid: Number,
      happIsSelected: true,
      showHappList: true,
      items: [],
      errors: [],
      radio: null,
      radionumber: Number,
      posthapp: {
        happ: [],
        regId: Number,
        ac: String,
      },
      postregidac: {
        regId: Number,
        ac: String,
      },
      roles: [],
      IsHappAdmin: false,
      IsBoxAdmin: false,
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";

    this.getCookies();
    this.happ = null;
    this.happname = "None Selected";
    this.roles = null;
    this.IsHappAdmin = false;
    this.IsBoxAdmin = false;
    this.getroles();
    // this.radionumber = 1;
  },
  methods: {
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.regId = Number(this.cookieRegId);
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
    },
    happSelected(happSelected) {
      this.happ = happSelected;
      this.happname = happSelected.HappName;
      this.happid = happSelected.HappId;
      this.happIsSelected = true;
      this.showHappList = false;
      this.radionumber = null;
      this.radio = null;
      this.IsHappAdmin = true;

      this.posthapp.happ = happSelected;
      this.posthapp.regId = this.regId;
      this.posthapp.ac = this.ac;

      this.postregidac.regId = this.regId;
      this.postregidac.ac = this.ac;
    },
    radiochanged() {
      if (this.radio == "Sms") {
        this.radionumber = 1;
      }
      if (this.radio == "happAdmins") {
        this.radionumber = 2;
      }
      if (this.radio == "Edit") {
        this.radionumber = 3;
      }
      if (this.radio == "Create") {
        this.radionumber = 4;
        this.postregidac.regId = this.regId;
        this.postregidac.ac = this.ac;
      }
      if (this.radio == "Delete") {
        this.radionumber = 5;
      }
      if (this.radio == "Transfer pilots to box") {
        this.radionumber = 6;
      }
    },
    getroles() {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      var uri = this.baseUrl + "getroles";
      var regId = this.regId;
      var roleId = 2;
      var toSubmit = JSON.stringify({ regId, roleId });
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.roles = response.data;
          if (this.roles[0].RoleId == 2) {
            this.IsBoxAdmin = true;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // findrole(arr,roleId){
    //   console.log(arr); console.log(roleId);
    //   this.roleAdminId = arr.find(roleId);
    // }
  },
  components: {
    SelectHappForAdmin,
    NeedLogin,
    // happRoles,
    CreateHapp,
    Deletehapp,
    TransferPilotsFromHappToBox,
  },
};
</script>

          